<template>
  <div class="hero-sass hero-swiper-btn" id="home">
    <div class="container_f1 full-height">
      <div class="swiper-wrapper">
        
        <div class="swiper-slide hero-background">
        
          <div class="canvas-content hero-item text-center px-3">
            <div class="hero-content">
              <h2 class="h1 hero-content-title font-weight-light">
                PIF Automation for Cosmetics
              </h2>
              <h6 class="hero-content-subtitle">
                Improve regulatory compliance for cosmetic products with Product Information Files management
              </h6>
              <router-link :to="{ path: '/go' }" class="btn btn--green signup"
                >GET STARTED</router-link
              >
            </div>
            <!--
            <div class="hero-thumb">
              <img
                src="../assets/img/mac-screen-0.png"
                alt="hero thumb"
                height="650"
              />
            </div>
            -->
          </div>
          <canvas id="gradient-canvas"></canvas>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import '../assets/scripts/gradient.js'; 

export default {
  components: {
  },
  data() {
    return {
      bgImg: {
        //backgroundImage: `url(${require("../assets/img/hero-bg.jpg")})`,
      },
      swiperOption: {
        speed: 1500,
        loop: true,
        effect: "fade",
        autoplay: false,
        spaceBetween: 30,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  mounted(){
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variabls.scss";
@import "../assets/scss/elements/hero-sass.scss";

/*
.hero-background {
  background-image: linear-gradient(
      to top,
      rgba(255, 255, 255, 0.52),
      rgba(0, 0, 0, 0.73)
    ),
    url("../assets/img/hero-bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
*/
#gradient-canvas {
  width:100%;
  height:100%;
  background: #ef008f;
  --gradient-color-1: #ef008f; 
  --gradient-color-2: #6ec3f4; 
  --gradient-color-3: #7038ff;  
  --gradient-color-4: #ffba27;
  z-index:0;
}

.full {
  width: 100vw;
  height: 100vh;
}

.full-height {
  height: 50vw;
  min-height: 500px;
}

.canvas-content {
  z-index:100;
  position: absolute;
  height: 100%;
  width: 100%;
}

.canvas-content .hero-content-title, .canvas-content .hero-content-subtitle {
  mix-blend-mode: difference;
}

</style>
